import React from 'react'
import archive from "../../Assets/images/people.png";
import archive123 from "../../Assets/images/123.png";
import archive1234 from "../../Assets/images/1234.png";
// import pic1 from "../../Assets/images/pic1.jpg";

function AboutWhyChooseUs() {
    return (
        <>
            <section className="aon-why-choose2-area">
                <div className="container">
                    <div className="aon-why-choose2-box">
                        <div className="row">
                            {/* COLUMNS LEFT */}
                            <div className="col-lg-6 col-md-12">
                                <div className="aon-why-choose-info">
                                    <div className="section-head">
                                        <span className="aon-sub-title">Choose</span>
                                        <h2 className="aon-title">Why Choose us</h2>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                            do eiusmod tempor incididunt ut labore et dolore magna
                                            aliqua.
                                        </p>
                                    </div>
                                    <ul className="aon-why-choose-steps list-unstyled">
                                        <li className="d-flex">
                                            <div className="aon-w-choose-left aon-icon-effect">
                                                <div className="aon-w-choose-icon">
                                                    <i className="aon-icon">
                                                        <img src={archive} alt="" />
                                                    </i>
                                                </div>
                                            </div>
                                            <div className="aon-w-choose-right">
                                                <h4 className="aon-title">Connect to new customers</h4>
                                                <p>
                                                    Suspendisse tincidunt rutrum ante. Vestibulum elementum
                                                    ipsum sit amet turpis elementum lobortis.
                                                </p>
                                            </div>
                                        </li>
                                        <li className="d-flex">
                                            <div className="aon-w-choose-left aon-icon-effect">
                                                <div className="aon-w-choose-icon">
                                                    <i className="aon-icon">
                                                        <img src={archive123} alt="" />
                                                    </i>
                                                </div>
                                            </div>
                                            <div className="aon-w-choose-right">
                                                <h4 className="aon-title">Grow your revenue</h4>
                                                <p>
                                                    Suspendisse tincidunt rutrum ante. Vestibulum elementum
                                                    ipsum sit amet turpis elementum lobortis.
                                                </p>
                                            </div>
                                        </li>
                                        <li className="d-flex">
                                            <div className="aon-w-choose-left aon-icon-effect">
                                                <div className="aon-w-choose-icon">
                                                    <i className="aon-icon">
                                                        <img src={archive1234} alt="" />
                                                    </i>
                                                </div>
                                            </div>
                                            <div className="aon-w-choose-right">
                                                <h4 className="aon-title">
                                                    Build your online reputation
                                                </h4>
                                                <p>
                                                    Suspendisse tincidunt rutrum ante. Vestibulum elementum
                                                    ipsum sit amet turpis elementum lobortis.
                                                </p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {/* COLUMNS RIGHT */}
                            <div className="col-lg-6 col-md-12">
                                <div className="aon-why-choose2-line">
                                    <div className="aon-why-choose2-pic" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AboutWhyChooseUs
